import { Head } from "@inertiajs/react"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { CheckCircle } from "lucide-react"

export default function InvitationAlreadyAccepted() {
  return (
    <>
      <Head title="Invitación Ya Aceptada" />

      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-teal-50 to-slate-50 p-4">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <div className="mb-4 flex justify-center">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
                <CheckCircle className="h-8 w-8 text-green-600" />
              </div>
            </div>
            <CardTitle className="text-2xl">Invitación Ya Aceptada</CardTitle>
            <CardDescription>
              Esta invitación ya ha sido aceptada anteriormente.
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-4 text-center">
            <p className="text-muted-foreground text-sm">
              Si ya tienes una cuenta, puedes iniciar sesión para acceder a la
              plataforma.
            </p>

            <Button asChild className="w-full">
              <a href="/sign_in">Iniciar sesión</a>
            </Button>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
